import { ForgeChrome } from "./forge/components/ForgeChrome";

/**
 * AgentForge — desktop GUI agent under Forge Suite branding.
 * Web shell: wallet, brains, trust UX, run history. OS control via desktop companion.
 */
export function App() {
  return (
    <div className="af-app-shell">
      <ForgeChrome />
    </div>
  );
}

/* Shell height is owned by .af-app-shell (100dvh) — see forge-chrome.css */
